import React from "react";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Renders a single metadata row with a label on the left and a value on the right.
 * Used in the detail panel to display document properties.
 * @param {object} props
 * @param {string} props.label - Row label text
 * @param {React.ReactNode} props.value - Row value element
 * @returns {React.ReactElement}
 */
function DetailInfoRow({ label, value }) {
    const labelColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Flex justify="space-between" align="center" py="6px">
            <Text fontSize="0.8rem" fontWeight="500" color={labelColor}>{label}</Text>
            <Box>{value}</Box>
        </Flex>
    );
}

export default DetailInfoRow;
